// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"371":"5fbc3aff977a5c5a","627":"d1c6705b01888dd3","936":"f681e5ec34544ff5"}[chunkId] + ".js";
};